// Core
import React, { Component } from 'react';

//Redux
import { connect } from 'react-redux';
import { updateTeamFilters } from '../../actions';

// Components
import FilterBar from '../../components/FilterBar';
import Loader from 'components/Loader';

// Utilities
import moment from 'moment';
import TeamsTable from './Tables/TeamsTable';
import AgentsTable from './Tables/AgentsTable';

class Teams extends Component {
  UNSAFE_componentWillMount() {
    const endDate = moment();
    const startDate = moment().subtract(7, 'days');
    const params = { startDate, endDate };

    updateTeamFilters(params);

    this.state = {
      startDate: startDate,
      endDate: endDate,
    };
  }

  render() {
    return (
      <div>
        <FilterBar
          filterByDates
          filterByChannels
          filterByTags
          filterByTeams
          startDate={this.props.startDateTeams}
          endDate={this.props.endDateTeams}
          filter={updateTeamFilters}
        />
        <div>
          <AgentsTable
            params={this.props.params}
            agentStats={this.props.agentStats}
          />
        </div>
        <div>
          <TeamsTable
            params={this.props.params}
            teamStats={this.props.teamStats}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    agentStats: state.statsRoute.agentStats,
    teamStats: state.statsRoute.teamStats,
    fetchingTeamStats: state.statsRoute.fetchingTeamStats,
    startDateTeams: state.statsRoute.startDateTeams,
    endDateTeams: state.statsRoute.endDateTeams,
    fetchingAgentStats: state.statsRoute.fetchingAgentStats,
    params: state.location.params,
  };
};

export default connect(mapStateToProps)(Teams);
